import { useAppStore } from '../../hooks/useAppStore';
import { DynamicObject } from '../../utils/commonTypes';
import { sponserLogoStyle, sponserTextStyle } from './GameLandingScreenStyles';

interface SponserDetailsProps {
  extendedStyles: DynamicObject;
}

const SponserDetails: React.FC<SponserDetailsProps> = ({ extendedStyles }) => {
  const { gamificationState = {} } = useAppStore();
  const { config = null } = gamificationState;
  return (
    <div css={[extendedStyles]}>
      <p css={sponserTextStyle}>{config?.sponsorText}</p>
      <img
        css={sponserLogoStyle}
        src={config?.sponsorLogo}
        alt={'Sponser Logo'}
      />
    </div>
  );
};

export default SponserDetails;
